var $ = jQuery;

import Swiper from 'swiper';

$(document).on('ready', function(){
    if($('.review-swiper').length){
      $('.review-swiper').each(function(index){
          new Swiper($(this)[0], {
          slidesPerView: 3.2,
          mousewheelControl: true,
          loop: false,
          spaceBetween: 20,
          autoHeight: true,
          slidesOffsetAfter: 48,
          breakpoints: {
            300: {
              slidesPerView: 1.3,
              speed:800,
              autoHeight: false,
            },
            500: {
              slidesPerView: 2,
              speed:800,
              autoHeight: false,
           },
            1400: {
              slidesPerView: 3.2,
              autoHeight: true,
            },
          },
        });
      });
    }
  });
